export default __webpack_public_path__ + "static/1-1a410030689075100702ef30f777e770.png";